import roles from "@/roles";
export default [
  {
    icon: "local_shipping",
    title: "Couriers",
    roles: [roles.ADMIN, roles.COURIER_ADMIN],
    children: [
      {
        icon: "compare_arrows",
        router: true,
        title: "Courier Invoice",
        to: "InvoiceAudit",
        roles: [roles.ADMIN, roles.COURIER_ADMIN]
      },
      {
        icon: "local_shipping",
        router: true,
        title: "Courier Config",
        to: "CourierConfig",
        roles: [roles.ADMIN, roles.COURIER_ADMIN]
      }
    ]
  }
];
